import api from "../../config/client.axios.api";

export const getErrorAndTestTransactionApi = async (
  accountId: string,
  startDate: string,
  endDate: string
) => {
  const response = await api.get(`/record-transaction/error-and-test`, {
    params: {
      accountId: accountId && accountId,
      startDate,
      endDate,
    },
  });
  return response.data;
};
